import { styled, ToucanButton } from "toucan";

/* One column of prose and the one action, centred in the canvas rather
   than filling it. */
const Page = styled("section")`
  min-height: 100%;
  background: var(--toucan-canvas);

  .connect {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    max-width: 26rem;
    margin: 0 auto;
    padding: 3rem 1rem;
    text-align: center;
  }
`;

/**
 * The page an unconnected browser is held at, with the one button that gets
 * it past. It offers the login rather than starting it, so a refusal or a
 * cancelled client id leaves you looking at this page instead of being sent
 * straight back to Spotify.
 */
export function ConnectPage({ onConnect }: { onConnect: () => void }) {
  return (
    <Page>
      <div class="connect">
        <h2>Connect Spotify</h2>
        <p>
          Toucan Music plays your albums through Spotify, searches it for the
          ones you add, and imports the collection you already keep there. It
          needs an account before it can do any of that.
        </p>
        <ToucanButton variant="primary" onClick={onConnect}>
          Connect Spotify
        </ToucanButton>
      </div>
    </Page>
  );
}
